import React, { useEffect, useState } from "react";
import { GetHistory } from "adminApi/CustomersApi/CustomerRefund";

const RefundHistoryModal = ({ customer, show, onClose }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !customer) return;
    setLoading(true);
    GetHistory(customer.customer_id)
      .then((res) => {
        if (res?.data?.success) setRows(res.data.data || []);
      })
      .finally(() => setLoading(false));
  }, [show, customer]);

  if (!show || !customer) return null;

  return (
    <>
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1040 }}
        onClick={onClose}
      />
      <div
        className="modal fade show d-block"
        style={{ zIndex: 1055 }}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                Refund History — {customer.customer_name}
              </h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>
            <div className="modal-body position-relative">
              {loading ? (
                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                  <div
                    className="spinner-border spinner-border-sm text-primary mb-3"
                    role="status"
                    aria-hidden="true"
                  ></div>

                  <span className="text-muted small">
                    Loading refund history...
                  </span>
                </div>
              ) : rows.length === 0 ? (
                <p className="text-muted text-center mb-0">
                  No refund history found.
                </p>
              ) : (
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Date & Time</th>
                      <th>Refund Amount</th>
                      <th>Balance After Refund</th>
                      <th>Payment Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {rows.map((r) => (
                      <tr key={r.refund_id}>
                        <td>
                          {new Date(r.created_at).toLocaleString("en-IN")}
                        </td>

                        <td>₹ {parseFloat(r.amount).toFixed(2)}</td>

                        <td>
                          {r.balance_after != null
                            ? `₹ ${parseFloat(r.balance_after).toFixed(2)}`
                            : "—"}
                        </td>

                        <td>
                          <span
                            className={`badge bg-${
                              r.status === "completed"
                                ? "success"
                                : r.status === "rejected"
                                  ? "danger"
                                  : "warning"
                            }`}
                          >
                            {r.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RefundHistoryModal;
